<template>
  <div
    v-if="displayQuote"
    class="order-reference-quote"
    :class="{ 'is-service': isService }"
    @click.stop="onClick"
  >
    <p v-if="displayQuote.senderName" class="order-reference-quote__sender">
      {{ displayQuote.senderName }}
    </p>
    <p class="order-reference-quote__summary">{{ displayQuote.summary }}</p>
  </div>
</template>

<script>
/**
 * V2 工单引用摘要（REFERENCE_MSG），展示规则见 v2-order-c-reference-msg-frontend.md
 */
export function normalizeOrderReferenceMsg(raw) {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const summary = String(raw.SUMMARY ?? raw.summary ?? '').trim();
  const senderName = String(raw.SENDER_NAME ?? raw.senderName ?? '').trim();
  const id = raw.ID ?? raw.id;
  if (!summary && !senderName) {
    return null;
  }
  return {
    id,
    senderName,
    summary: summary || senderName
  };
}

export default {
  name: 'OrderReferenceQuote',
  props: {
    referenceMsg: {
      type: Object,
      default: null
    },
    isService: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayQuote() {
      return normalizeOrderReferenceMsg(this.referenceMsg);
    }
  },
  methods: {
    onClick() {
      const targetId = this.displayQuote?.id;
      if (targetId != null && targetId !== '') {
        this.$emit('scroll-to-message', targetId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.order-reference-quote {
  box-sizing: border-box;
  /* 与气泡正文 .cont-msg 同字号（继承 .cont） */
  font-size: inherit;
  line-height: inherit;
  margin-bottom: 6px;
  padding: 4px 6px 4px 8px;
  border-left: 2px solid var(--main-color);
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.04);
  cursor: pointer;

  &__sender {
    margin: 0 0 2px;
    font-size: inherit;
    line-height: inherit;
    font-weight: 600;
    color: var(--main-color);
  }

  &__summary {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
    color: var(--placeholder-color);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-word;
  }

  &.is-service {
    border-left-color: rgba(255, 255, 255, 0.85);
    background-color: rgba(0, 0, 0, 0.12);

    .order-reference-quote__sender {
      color: var(--text-on-main-bg-color);
      opacity: 0.95;
    }

    .order-reference-quote__summary {
      color: var(--text-on-main-bg-color);
      opacity: 0.75;
    }
  }
}
</style>
